import { Injectable } from '@angular/core';
import { LatLng } from 'leaflet';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MapService {

  private readonly stationsToShowSource = new Subject<string>();
  stationsToShow$ = this.stationsToShowSource.asObservable();

  private readonly highlightIdSource = new Subject<string>();
  highlightId$ = this.highlightIdSource.asObservable();

  private readonly highlightEndIdSource = new Subject<string>();
  highlightEndId$ = this.highlightEndIdSource.asObservable();

  private readonly pathToShowSource = new Subject<{ path: string; position: LatLng | undefined; type: string | undefined }>();
  pathToShow$ = this.pathToShowSource.asObservable();

  private readonly mapCenterOnSource = new Subject<string>();
  mapCenterOn$ = this.mapCenterOnSource.asObservable();

  constructor() { }

  showPath(data: [path: string, connId: string, position: LatLng | undefined, type: string | undefined]) {
    this.pathToShowSource.next({ path: data[0], position: data[2], type: data[3]});
    this.mapCenterOnSource.next(data[1]);
  }

  hidePath(connId: string) {
    this.pathToShowSource.next({ path: "", position: undefined, type: ""});
  }

  highlightConnection(id: string): void {
    this.highlightIdSource.next(id);
  }

  highlightConnectionEnd(id: string): void {
    this.highlightEndIdSource.next(id);
  }
}
